import "./FilterPopup.scss";
import { Box, Dialog, DialogContent, Rating, Slider, Radio } from "@mui/material";
import { useEffect, useState } from "react";
import { axiosInstance } from "../../Utilities/Interceptor/Interceptor";
import { API_END_POINTS, GLOBAL_CONSTANTS, GradeViewArray } from "../../Constants/Constants";
import { store } from "../../Redux/Store/Store";
import { setLoader } from "../../Redux/Reducer/Reducer";
import { nullUndefinedEmptyCheck, SetSessionStorageData } from "../../Utilities/Helpers/Helper";
import { useTranslation } from "react-i18next";
import { useTheme, useMediaQuery } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";

const school_ratings = ["Outstanding", "Good", "Excellent", "Acceptable", "Unsatisfactory"];

const FilterPopup = ({ FilterPopOpen, onClosePop, type, color, initFilter, initSort, handleSortValue, handleSingleBubbleSelect, items, FilterData, handleRangeValue, FilterReset, ApplyBtn, marks, rangeSets, handleSingleSliderValue, checkArrayEqual, handleOnChange }: any) => {


    const { t } = useTranslation();
    const [ActiveState, setActiveState] = useState<any>(1);
    const [CheckedPrice, setCheckedPrice] = useState<any>(initSort?.price);
    const [CheckedRating, setCheckedRating] = useState<any>(initSort?.rating);
    const [theRating, setTHERating] = useState<any>(initSort.the_rating);
    const [shRating, setSHRating] = useState<any>(initSort.sh_rating);
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('sm'));
    
    const handleSort = (CheckedPrice:any, CheckedRating:any, theRating:any , shRating:any ) => {
        let sort = {
            price: CheckedPrice,
            rating: CheckedRating,
            the_rating: theRating,
            sh_rating: shRating,
        }
        SetSessionStorageData("sort", JSON.stringify(sort))
        SetSessionStorageData("sort_price",CheckedPrice)
        SetSessionStorageData("sort_rating", CheckedRating)
        handleSortValue(CheckedPrice, CheckedRating, theRating, shRating)
    }

    const handleReset = () => {
        setCheckedPrice("");
        setCheckedRating('');
        setTHERating('');
        setSHRating('');
        FilterReset('all')
    }
   
    const active_contant_text = {
        background: color,
        color: "#FFF",
        border: `1px solid ${color}`
    }

    const range_slider = {
        color: { color },
        '& .MuiSlider-thumb': {
            backgroundColor: { color },
        },
        '& .MuiSlider-track': {
            backgroundColor: { color },
        },
        width: '80%',
        margin: "0px 10px",
        '& .MuiSlider-markLabel': {
            color: '#333333', 
            fontSize: '12px', 
            whiteSpace: "pre-wrap",
            textAlign: "center",
            fontFamily: "Manrope500",
            width: "30px",
        },
    }

    const timeFormat = (value: number) => {
        if (value === 24) {
            return `23:59`;
        }
        const hours = Math.floor(value);
        const minutes = (value % 1) * 60;
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    }

    
    const viewGradeName = (val: number) => {
        const result = GradeViewArray.find((item) => item.id === val);
        return result ? result.label : null; 
    };
    


    return (
        <>
            <Dialog open={FilterPopOpen} sx={{
                
                minWidth: matches ? 'auto' : '600px',
            }}>
                <DialogContent>
                    <div className="TutorFilterPop_conatiner">
                        <div className="Filter_header__wapper">
                            <div className="header_title_wapper">
                                <div className={ActiveState == 1 ? "header_title_active" : "header_title"} style={ActiveState == 1 ? active_contant_text : {}} onClick={() => setActiveState(1)} >{t("Filters")}</div>
                                <div className={ActiveState == 2 ? "header_title_active" : "header_title"} style={ActiveState == 2 ? active_contant_text : {}} onClick={() => setActiveState(2)}>{t("Sort")}</div>
                            </div>
                            {
                                matches?
                            <CloseIcon className="close__icon"  onClick={onClosePop} />:
                            <span className="close__text" onClick={onClosePop}>{t("close")}</span>

                            }
                        </div>

                        {ActiveState == 1 ? (
                            <div className="Filter__body__contant">

                                {type === "school" && initFilter.hasOwnProperty('rating') ?
                                    <div className="contant__wapper mb-4">
                                        <div className="title_text">{t("Ratings")}</div>
                                        <div className="bobules__wapper">
                                            {(FilterData?.rating ? FilterData?.rating : school_ratings)?.map((item: any) => {
                                                if (item) {
                                                    return (
                                                        <>
                                                            <div className="contant_text" style={items?.rating?.includes(item) ? active_contant_text : {}} onClick={() => handleSingleBubbleSelect("rating", item)}>{item}</div>
                                                        </>
                                                    )
                                                }
                                            })}
                                        </div>
                                    </div> : ""}

                                {initFilter?.hasOwnProperty('curriculum') ?
                                    <div className="contant__wapper  mb-4">
                                        <div className="title_text">{t("Curriculum")}</div>
                                        <div className="bobules__wapper">
                                            {FilterData?.curriculum?.map((item: any) => {
                                                return (
                                                    <>
                                                        <div className="contant_text" style={items?.curriculum?.includes(item) ? active_contant_text : {}} onClick={() => handleSingleBubbleSelect("curriculum", item)}>{item}</div>
                                                    </>
                                                )
                                            })}
                                            <div className="contant_text" style={items?.curriculum?.length === 0 ? active_contant_text : {}} onClick={() => handleSingleBubbleSelect("curriculum", "all")}> All </div>

                                        </div>
                                    </div>
                                    : ""}

                                {initFilter.hasOwnProperty('activities') ?
                                    <div className="contant__wapper  mb-4">
                                        <div className="title_text">{t("Activities")}</div>
                                        <div className="bobules__wapper">
                                            {FilterData.activities?.map((item: any) => {
                                                return (
                                                    <>
                                                        <div className="contant_text" style={items?.activities?.includes(item) ? active_contant_text : {}} onClick={() => handleSingleBubbleSelect("activities", item)}>{item}</div>
                                                    </>
                                                )
                                            })}
                                            <div className="contant_text" style={items?.activities?.length === 0 ? active_contant_text : {}} onClick={() => handleSingleBubbleSelect("activities", "all")}>{t("All")} </div>

                                        </div>
                                    </div>
                                    : ""}

                                {initFilter.hasOwnProperty('programs') ?

                                    <div className="contant__wapper  mb-4">
                                        <div className="title_text">{t("Programs")}</div>
                                        <div className="bobules__wapper">
                                            {FilterData.programs?.map((item: any) => {
                                                return (
                                                    <>
                                                        <div className="contant_text" style={items?.programs?.includes(item) ? active_contant_text : {}} onClick={() => handleSingleBubbleSelect("programs", item)}>{item}</div>
                                                    </>
                                                )
                                            })}
                                            <div className="contant_text" style={items?.programs?.length === 0 ? active_contant_text : {}} onClick={() => handleSingleBubbleSelect("programs", "all")}>{t("All")} </div>

                                        </div>
                                    </div>
                                    : ""}

                                {initFilter.hasOwnProperty('language_instruction') ?

                                    <div className="contant__wapper  mb-4">
                                        <div className="title_text">{t("Language of Instruction")}</div>
                                        <div className="bobules__wapper">
                                            {FilterData.language_instruction?.map((item: any) => {
                                                return (
                                                    <>
                                                        <div className="contant_text" style={items?.language_instruction?.includes(item) ? active_contant_text : {}} onClick={() => handleSingleBubbleSelect("language_instruction", item)}>{item}</div>
                                                    </>
                                                )
                                            })}
                                            <div className="contant_text" style={items?.language_instruction?.length === 0 ? active_contant_text : {}} onClick={() => handleSingleBubbleSelect("language_instruction", "all")}>{t("All")} </div>


                                        </div>
                                    </div>
                                    : ""}

                                {initFilter.hasOwnProperty('courses') ?

                                    <div className="contant__wapper mb-4">
                                        <div className="title_text">{t("Course Category")}</div>
                                        <div className="bobules__wapper">
                                            {FilterData.courses?.map((item: any) => {
                                                return (
                                                    <>
                                                        <div className="contant_text" style={items?.courses?.includes(item) ? active_contant_text : {}} onClick={() => handleSingleBubbleSelect("courses", item)}>{item}</div>
                                                    </>
                                                )
                                            })}
                                            <div className="contant_text" style={items?.courses?.length === 0 ? active_contant_text : {}} onClick={() => handleSingleBubbleSelect("courses", "all")}>{t("All")} </div>

                                        </div>
                                    </div> : ""}

                                {initFilter.hasOwnProperty('experience') ?

                                    <div className="contant__wapper mb-4">
                                        <div className="title_text">{t("Years of Experience")}</div>
                                        <div className="price_range">
                                            <span style={{ color: color }}>{items.experience[0]}</span>{t(" Year - ")}<span style={{ color: color }}>{items.experience[1]}</span> {t("Year")}
                                        </div>
                                       
                                        <div className="bobules__wapper" style={{ marginBottom: "35px" }}>
                                            <Slider
                                                value={items.experience}
                                                onChange={(event, newValue) => handleRangeValue("experience", newValue)}
                                                valueLabelDisplay="auto"
                                                min={0}
                                                max={FilterData.experience?.max}
                                                step={1}
                                                marks={marks.experience}
                                                sx={range_slider}
                                            />
                                        </div>
                                    </div> : ""}

                                {initFilter.hasOwnProperty('mode_of_teaching') ?

                                    <div className="contant__wapper mb-4">
                                        <div className="title_text">{t("Mode Of Teaching")}</div>
                                        <div className="bobules__wapper">
                                            {FilterData.mode_of_teaching?.map((item: any) => {
                                                return (
                                                    <>
                                                        <div className="contant_text" style={items?.mode_of_teaching?.includes(item) ? active_contant_text : {}} onClick={() => handleSingleBubbleSelect("mode_of_teaching", item)}>{item == 'Offline' ? t("On-premises") : item}</div>
                                                    </>
                                                )
                                            })}
                                            <div className="contant_text" style={items?.mode_of_teaching?.length === 0 ? active_contant_text : {}} onClick={() => handleSingleBubbleSelect("mode_of_teaching", "all")}>{t("All")} </div>

                                        </div>
                                    </div> : ""}

                                {initFilter.hasOwnProperty('gender') ?

                                    <div className="contant__wapper mb-4">
                                        <div className="title_text">{t("Gender")}</div>
                                        <div className="bobules__wapper">
                                            {FilterData.gender?.map((item: any) => {
                                                return (
                                                    <>
                                                        <div className="contant_text" style={items?.gender?.includes(item) ? active_contant_text : {}} onClick={() => handleSingleBubbleSelect("gender", item)}>{item}</div>
                                                    </>
                                                )
                                            })}
                                            <div className="contant_text" style={items?.gender?.length === 0 ? active_contant_text : {}} onClick={() => handleSingleBubbleSelect("gender", "all")}>{t("All")} </div>

                                        </div>
                                    </div> : ""}

                                {type === "tutor" || type === "activity" && initFilter.hasOwnProperty('rating') ?

                                    <div className="contant__wapper mb-4">
                                        <div className="title_text">{t("Ratings")}</div>
                                        <div className="bobules__wapper">
                                            <Rating
                                                name="rating"
                                                precision={0.5}
                                                value={items.rating}
                                                onChange={handleOnChange}
                                            />
                                            <div className="price_range" style={{ color: color }}>{items.rating}</div>
                                        </div>
                                    </div> : ""}


                                {initFilter.hasOwnProperty('qs_ranking') ?

                                    <div className="contant__wapper mb-4">
                                        <div className="title_text">{t("QS Ranking")}</div>
                                        <div className="price_range">
                                            <span style={{ color: color }}>{items.qs_ranking[0] === 0 ? GLOBAL_CONSTANTS.INITIAL_VALUES.NA : items.qs_ranking[0]}</span> - <span style={{ color: color }}>{items.qs_ranking[1] === 0 ? GLOBAL_CONSTANTS.INITIAL_VALUES.NA : items.qs_ranking[1]}</span>
                                        </div>
                                        <div className="bobules__wapper" >
                                            <Slider
                                                value={items.qs_ranking}
                                                onChange={(event, newValue) => handleRangeValue("qs_ranking", newValue)}
                                                valueLabelDisplay="auto"
                                                min={0}
                                                
                                                max={FilterData.qs_ranking?.max}
                                                step={1}
                                                sx={range_slider}

                                            />
                                        </div>
                                    </div> : ""}

                                {initFilter.hasOwnProperty('the_ranking') ?

                                    <div className="contant__wapper mb-4">
                                        <div className="title_text">{t("THE Ranking")}</div>
                                        <div className="price_range">
                                            <span style={{ color: color }}>{items.the_ranking[0] === 0 ? GLOBAL_CONSTANTS.INITIAL_VALUES.NA : items.the_ranking[0]}</span> - <span style={{ color: color }}>{items.the_ranking[1] === 0 ? GLOBAL_CONSTANTS.INITIAL_VALUES.NA : items.the_ranking[1]}</span>
                                        </div>
                                        <div className="bobules__wapper" >
                                            <Slider
                                                value={items.the_ranking}
                                                onChange={(event, newValue) => handleRangeValue("the_ranking", newValue)}
                                                valueLabelDisplay="auto"
                                                min={0}
                                                
                                                max={FilterData.the_ranking?.max}
                                                step={1}
                                                sx={range_slider}

                                            />
                                        </div>
                                    </div> : ""}

                                {initFilter.hasOwnProperty('sh_ranking') ?

                                    <div className="contant__wapper mb-4">
                                        <div className="title_text">{t("SH Ranking")}</div>
                                        <div className="price_range">
                                            <span style={{ color: color }}>{items.sh_ranking[0] === 0 ? GLOBAL_CONSTANTS.INITIAL_VALUES.NA : items.sh_ranking[0]}</span> - <span style={{ color: color }}>{items.sh_ranking[1] === 0 ? GLOBAL_CONSTANTS.INITIAL_VALUES.NA : items.sh_ranking[1]}</span>
                                        </div>
                                        <div className="bobules__wapper" >
                                            <Slider
                                                value={items.sh_ranking}
                                                onChange={(event, newValue) => handleRangeValue("sh_ranking", newValue)}
                                                valueLabelDisplay="auto"
                                                min={0}
                                                
                                                max={FilterData.sh_ranking?.max}
                                                step={1}
                                                sx={range_slider}

                                            />
                                        </div>
                                    </div> : ""}

                                {(type === 'tutor' || type === "school") && initFilter.hasOwnProperty('grade') ?

                                    <div className="contant__wapper mb-4">
                                        <div className="title_text">{t("Grade")}</div>
                                        <div className="price_range">
                                            <span style={{ color: color }}>{viewGradeName(items.grade[0])}</span> - <span style={{ color: color }}>{viewGradeName(items.grade[1])}</span>
                                        </div>
                                        <div className="bobules__wapper" >
                                            <Slider
                                                value={items.grade}
                                                onChange={(event, newValue) => handleRangeValue("grade", newValue)}
                                                valueLabelDisplay="auto"
                                                min={FilterData.grade?.min}
                                                max={FilterData.grade?.max}
                                                step={1}
                                                sx={range_slider}
                                                valueLabelFormat={(value) => viewGradeName(value)}
                                            />
                                        </div>
                                    </div> : ""}

                                {initFilter.hasOwnProperty('age') ?

                                    <div className="contant__wapper mb-4">
                                        <div className="title_text">{t("Age")}</div>
                                        <div className="price_range">
                                            <span style={{ color: color }}>{items.age[0]}</span> - <span style={{ color: color }}>{items.age[1]}</span>
                                        </div>
                                        <div className="bobules__wapper" >
                                            <Slider
                                                value={items.age}
                                                onChange={(event, newValue) => handleRangeValue("age", newValue)}
                                                valueLabelDisplay="auto"
                                                min={FilterData.age?.min}
                                                max={FilterData.age?.max}
                                                step={1}
                                                sx={range_slider}

                                            />
                                        </div>
                                    </div> : ""}

                                {initFilter.hasOwnProperty('available') ?
                                    <div className="contant__wapper  mb-4">
                                        <div className="title_text">{t("Availability")}</div>
                                        <div className="bobules__wapper">
                                            {FilterData.available?.map((item: any) => {
                                                return (
                                                    <>
                                                        <div className="contant_text" style={items?.available?.includes(item) ? active_contant_text : {}} onClick={() => handleSingleBubbleSelect("available", item)}>{item}</div>
                                                    </>
                                                )
                                            })}

                                        </div>
                                        <div className="price_range">
                                            {t("Time:")} <span style={{ color: color }}>{timeFormat(items.time[0])}</span> - <span style={{ color: color }}>{timeFormat(items.time[1])}</span>
                                        </div>
                                        <div className="bobules__wapper" >
                                            <Slider
                                                value={items.time}
                                                onChange={(event, newValue) => handleRangeValue("time", newValue)}
                                                valueLabelDisplay="auto"
                                                valueLabelFormat={(value) => timeFormat(value)}
                                                min={0}
                                                max={24}
                                                step={1}
                                                sx={range_slider}

                                            />
                                        </div>
                                    </div>
                                    : ""}




                                {initFilter.hasOwnProperty('price') ?

                                    <div className="contant__wapper mb-4">
                                        <div className="title_text">{t("Avg Fees")}</div>
                                        <div className="price_range">
                                            {t("AED")}.<span style={{ color: color }}>{items?.price[0]}</span>{t("- AED")}.<span style={{ color: color }}>{items?.price[1]}</span>
                                        </div>
                                        <div className="bobules__wapper">
                                            {rangeSets?.price?.map((item: any) => {
                                                return (
                                                    <>
                                                        <div className="contant_text" style={checkArrayEqual(item?.value, items?.price) ? active_contant_text : {}} onClick={() => handleRangeValue("price", item.value)}>{item.name}</div>
                                                    </>
                                                )
                                            })}
                                        </div>
                                        <div className="bobules__wapper" style={{ marginBottom: "35px" }}>
                                            <Slider
                                                value={items?.price}
                                                onChange={(event, newValue) => handleRangeValue("price", newValue)}
                                                valueLabelDisplay="auto"
                                                min={0}
                                                max={FilterData?.price?.max}
                                                step={100}
                                                marks={marks?.price}
                                                sx={range_slider}
                                            />
                                        </div>
                                    </div> : ""}



                                {initFilter.hasOwnProperty('radius') ?

                                    <div className="contant__wapper mb-4">
                                        <div className="title_text">{t("Map Location Radius")}</div>
                                        <div className="price_range">
                                            <span style={{ color: color }}>{items?.radius}</span>{t("KM")}
                                        </div>
                                        <div className="bobules__wapper">
                                            <Slider
                                                value={items?.radius} 
                                                onChange={(event, newValue) => handleSingleSliderValue("radius", newValue)}
                                                valueLabelDisplay="auto"
                                                min={0}
                                                max={1000}
                                                step={1}
                                                sx={{
                                                    color: { color },
                                                    '& .MuiSlider-thumb': {
                                                        backgroundColor: { color },
                                                    },
                                                    '& .MuiSlider-track': {
                                                        backgroundColor: { color },
                                                    },
                                                    width: '80%',
                                                    margin: "0px 10px"
                                                }}
                                            />
                                        </div>
                                    </div> : ""}
                            </div>
                        ) : (
                            <div className="Filter__body__contant">
                                <div className="contant__wapper  mb-4">
                                    <div className="title_text"><b>{t("Price")}</b></div>
                                    <div className="contant__wapper">
                                        <div className="sorting_wapper">
                                            <div className="sorting_text_">{t("High price to Low price")}</div>
                                            <Radio
                                                onChange={() => {
                                                    setCheckedPrice('high')
                                                    setCheckedRating('');
                                                    setTHERating('');
                                                    setSHRating('');
                                                }}
                                                checked={CheckedPrice == 'high' ? true : false}
                                                name={CheckedPrice == 'high' ? 'radio-button-on' : 'radio-button-off'}
                                                sx={{
                                                    color: color,
                                                    '&.Mui-checked': {
                                                        color: color,
                                                    },
                                                }} />
                                        </div>
                                    </div>
                                    <div className="contant__wapper">
                                        <div className="sorting_wapper">
                                            <div className="sorting_text_">{t("Low price to High price")}</div>
                                            <Radio
                                                onChange={() => {
                                                    setCheckedPrice('low');
                                                    setCheckedRating('');
                                                    setTHERating('');
                                                    setSHRating('');
                                                }}
                                                checked={CheckedPrice == 'low' ? true : false}
                                                name={CheckedPrice == 'low' ? 'radio-button-on' : 'radio-button-off'}
                                                sx={{
                                                    color: color,
                                                    '&.Mui-checked': {
                                                        color: color,
                                                    },
                                                }} />
                                        </div>
                                    </div>
                                </div>

                                {/* QS Rating */}
                                <div className="contant__wapper  mb-4">
                                    <div className="title_text"><b>{t(type === "university" ? "QS Ranking" : "Rating")}</b></div>
                                    <div className="contant__wapper">
                                        <div className="sorting_wapper">
                                            <div className="sorting_text_">{t(type === "university" ? "Ascending" :"Highest to lowest")}</div>
                                            <Radio
                                                onChange={() => {
                                                    setCheckedRating('high');
                                                    setCheckedPrice("");
                                                    setTHERating('');
                                                    setSHRating('');
                                                }}
                                                checked={CheckedRating == 'high' ? true : false}
                                                name={CheckedRating == 'high' ? 'radio-button-on' : 'radio-button-off'}
                                                sx={{
                                                    color: color,
                                                    '&.Mui-checked': {
                                                        color: color,
                                                    },
                                                }} />
                                        </div>
                                    </div>
                                        <div className="contant__wapper">
                                            <div className="sorting_wapper">
                                                <div className="sorting_text_">{t(type === "university" ? "Desending" : "Lowest to highest")}</div>
                                                <Radio
                                                    onChange={() => {
                                                        setCheckedRating('low');
                                                        setCheckedPrice("");
                                                        setTHERating('');
                                                        setSHRating('');
                                                    }}
                                                    checked={CheckedRating == 'low' ? true : false}
                                                    name={CheckedRating == 'low' ? 'radio-button-on' : 'radio-button-off'}
                                                    sx={{
                                                        color: color,
                                                        '&.Mui-checked': {
                                                            color: color,
                                                        },
                                                    }} />
                                            </div>
                                        </div>

                                        {type === "university" &&
                                            <div className="contant__wapper  mb-4">
                                                <div className="title_text"><b>{t("THE Ranking")}</b></div>
                                                <div className="contant__wapper">
                                                    <div className="sorting_wapper">
                                                        <div className="sorting_text_">{t("Ascending")}</div>
                                                        <Radio
                                                            onChange={() => {
                                                                setTHERating('high');
                                                                setCheckedRating('');
                                                                setCheckedPrice("");
                                                                setSHRating('');
                                                            }}
                                                            checked={theRating == 'high' ? true : false}
                                                            name={theRating == 'high' ? 'radio-button-on' : 'radio-button-off'}
                                                            sx={{
                                                                color: color,
                                                                '&.Mui-checked': {
                                                                    color: color,
                                                                },
                                                            }} />
                                                    </div>
                                                </div>
                                                <div className="contant__wapper">
                                                    <div className="sorting_wapper">
                                                        <div className="sorting_text_">{t("Desending")}</div>
                                                        <Radio
                                                            onChange={() => {
                                                                setTHERating('low');
                                                                setCheckedRating('');
                                                                setCheckedPrice("");
                                                                setSHRating('');
                                                            }}
                                                            checked={theRating == 'low' ? true : false}
                                                            name={theRating == 'low' ? 'radio-button-on' : 'radio-button-off'}
                                                            sx={{
                                                                color: color,
                                                                '&.Mui-checked': {
                                                                    color: color,
                                                                },
                                                            }} />
                                                    </div>
                                                </div>
                                            </div>}

                                        {type === "university" &&
                                            <div className="contant__wapper  mb-4">
                                                <div className="title_text"><b>{t("SH Ranking")}</b></div>
                                                <div className="contant__wapper">
                                                    <div className="sorting_wapper">
                                                        <div className="sorting_text_">{t("Ascending")}</div>
                                                        <Radio
                                                            onChange={() => {
                                                                setSHRating('high');
                                                                setCheckedRating('');
                                                                setCheckedPrice("");
                                                                setTHERating('');
                                                            }}
                                                            checked={shRating == 'high' ? true : false}
                                                            name={shRating == 'high' ? 'radio-button-on' : 'radio-button-off'}
                                                            sx={{
                                                                color: color,
                                                                '&.Mui-checked': {
                                                                    color: color,
                                                                },
                                                            }} />
                                                    </div>
                                                </div>
                                                <div className="contant__wapper">
                                                    <div className="sorting_wapper">
                                                        <div className="sorting_text_">{t("Desending")}</div>
                                                        <Radio
                                                            onChange={() => {
                                                                setSHRating('low');
                                                                setCheckedRating('');
                                                                setCheckedPrice("");
                                                                setTHERating('');
                                                            }}
                                                            checked={shRating == 'low' ? true : false}
                                                            name={shRating == 'low' ? 'radio-button-on' : 'radio-button-off'}
                                                            sx={{
                                                                color: color,
                                                                '&.Mui-checked': {
                                                                    color: color,
                                                                },
                                                            }} />
                                                    </div>
                                                </div>
                                            </div>}

                                </div>
                            </div>
                        )}


                        <div className="Filter__footer__wapper">
                            {ActiveState == 1 ? (
                                <button className="applyBtn" style={{ backgroundColor: color }} onClick={ApplyBtn}>{t("Apply")}</button>
                            ) : (
                                <button className="applyBtn" style={{ backgroundColor: color }} onClick={() => handleSort(CheckedPrice, CheckedRating, theRating, shRating)}>{t("Apply")}</button>
                            )}
                            <button className="resetBtn" onClick={handleReset }>{t("Reset")}</button>
                        </div>

                    </div>

                </DialogContent>

            </Dialog>
        </>
    )
}

export default FilterPopup;